module.exports = __webpack_public_path__ + "media/flags/kn-035ea8e7.svg";